//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import CalendarTermDialogForEdit from "@/components/serveSearch/calendar/CalendarTermDialogForEdit";
export default {
  name: "TermDialog",
  components: {
    Sift: Sift,
    CalendarTermDialogForEdit: CalendarTermDialogForEdit
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      show: false,
      siftData: [],
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 20
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    addItem: function addItem() {
      this.$refs.calendarTermDialogForEdit.showView(null, false);
    },
    editItem: function editItem(item) {
      this.$refs.calendarTermDialogForEdit.showView(item, true);
    },
    deleteItem: function deleteItem(item) {
      var _this = this;

      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.loading = true;

        _this.$http.delete("/calendar/delete", {
          params: {
            id: item.wid
          }
        }).then(function (_ref) {
          var data = _ref.data;

          if (data.resCode == "0") {
            _this.$message.success(data.resMsg);

            _this.fetchList();
          }

          _this.loading = false;
        }).catch(function (err) {
          _this.loading = false;
        });
      }).catch(function () {});
    },
    fetchSiftData: function fetchSiftData() {
      var _this2 = this;

      this.loading = true;
      this.$http.post("/calendar/listCondition").then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == "0") {
          _this2.siftData = data.resData;

          _this2.$nextTick(function () {
            _this2.initPage();
          });
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    fetchList: function fetchList() {
      var _this3 = this;

      var obj = {};

      if (this.siftData.length > 0) {
        obj = this.$refs.sift.getValue();
      }

      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;
      this.loading = true;
      this.$http.post("/calendar/calendarlist", this.$qs.stringify(obj)).then(function (_ref3) {
        var data = _ref3.data;

        if (data.resCode == "0") {
          _this3.list = data.resData.list;
          _this3.total = data.resData.total;
        }

        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage: function changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    initPage: function initPage() {
      this.pageNum = 1;
      this.fetchList();
    },
    showView: function showView() {
      var _this4 = this;

      this.show = true;

      if (this.siftData.length == 0) {
        this.$nextTick(function () {
          _this4.fetchSiftData();
        });
      }
    },
    closed: function closed() {
      this.$parent.getSiftData();
      this.$emit("init-page");
    }
  }
};